module.exports = __webpack_public_path__ + "static/media/6.afca6dd3.jpg";